<template>
    <div>
        <div class="page-title">View Template</div>
         <div class="page-box">
               <el-form ref="ruleForm" :model="form"  label-width="180px">
                    <el-form-item label="Template Tittle" >
                        <el-input disabled v-model="form.title"></el-input>
                    </el-form-item>
                    <el-divider>Email Template</el-divider>
                    <el-form-item label="Subject" >
                            <el-input disabled v-model="form.email.subject"></el-input>
                        </el-form-item>
                    <el-form-item label="Body" >
                        <div v-html="form.email.body"></div>
                        </el-form-item>
                        <el-divider>Announcement Template</el-divider>
                    <el-form-item label="Subject" >
                            <el-input disabled v-model="form.announcement.subject"></el-input>
                        </el-form-item>
                    <el-form-item label="Body">
                        <div v-html="form.announcement.body"></div>
                    </el-form-item>
                </el-form>
                <el-button @click="onBack">Back</el-button>
         </div>
          
    </div>
</template>

<script>
    import {getTemplatesDetail} from '@/api/admin/notification'
    export default {
        props:{
            id:{
                type:Number,
                default:0
            }
        },
        data() {
            return {
                form: {
                    type: 3, 
                    statusTemplateType: 0, 
                    formType: 0, 
                    title: null, 
                    email: {
                        subject: null, 
                        body: null
                    }, 
                    announcement: {
                        subject: null, 
                        body: null
                    }
                }
            }
        },
        created(){
            this.getTemplatesDetail()
        },
        methods:{
             getTemplatesDetail(){
               getTemplatesDetail(this.id).then((v)=>{
                  this.form = v.data
               })
            },
        }
    }
</script>

<style lang="scss" scoped>
.page-box{
    background-color: #fff;
    padding-top: 20px;
    padding-bottom: 20px;
    margin-bottom: 20px;
}
</style>